import PropTypes from 'prop-types';
import React from 'react';

import GiftIcon from 'components/CartGiftMessagePrompt/GiftIcon';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const CartGiftMessagePrompt = props => {
  const { viewGiftMessage, isLogoFreePackagingAvailable } = props;

  return (
    <div className="CartGiftMessagePrompt">
      <GiftIcon />
      {I18n.localize('cart.giftMessagingPrompt.part1')}{' '}
      <button onClick={viewGiftMessage} className="CartGiftMessagePrompt__link">
        {isLogoFreePackagingAvailable
          ? I18n.localize('cart.giftMessagingPrompt.part2AllOptions')
          : I18n.localize('cart.giftMessagingPrompt.part2')}
      </button>
      <style jsx>
        {`
          .CartGiftMessagePrompt {
            width: 100%;
            font-size: ${Theme.get('font-size-small-px')};
            padding: ${Theme.get('spacing') * 2}px 0;
            letter-spacing: ${Theme.get('letter-spacing-px')};
          }

          .CartGiftMessagePrompt__link {
            background: none;
            border: none;
            padding: 0;
            font: inherit;
            cursor: pointer;
            outline: inherit;
            text-decoration: underline;
            color: ${Theme.get('colors-black')};
          }

          .CartGiftMessagePrompt__link.focused {
            outline: 2px solid ${Theme.get('colors-black')};
          }
        `}
      </style>
    </div>
  );
};

CartGiftMessagePrompt.propTypes = {
  viewGiftMessage: PropTypes.func.isRequired,
  isLogoFreePackagingAvailable: PropTypes.bool,
};

CartGiftMessagePrompt.defaultProps = {
  isLogoFreePackagingAvailable: false,
};

export default CartGiftMessagePrompt;
